import React, { useEffect, useState, useCallback } from "react";
import LaboralBulkLoadEmployeeFileInput from './file_input';
import LaboralBulkLoadEmployeeListHidden from './list_hidden';
import LaboralBulkLoadEmployeeTableErrors from './table_errors';
import LaboralBulkLoadEmployeeTable from './table';
import { validateEmail, validateName, formatToCurrency } from '../../../../helper/form';
import {
  alertConfirmDelete,
  getDataFilter
} from './config';
import { Label } from "reactstrap";
import {
  FormGroup,
  Button,
  UncontrolledTooltip
} from 'reactstrap';
import swal from "sweetalert2";
import _ from "lodash-es";

const LaboralBulkLoadEmployeeForm = (props) => {
  const formName = 'laboral_bulk_load_employee'
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState([]);
  const [isValid, setValid] = useState(false);
  const [disabledSubmitButton, setDisabledSubmitButton] = useState(false)
  const _controldoc_id = 'controldoc_id'
  const _headers_concat = _.concat(props.defaultHeaders, _.map(props.customFieldsHeaders, 'code'), _controldoc_id)
  const _security_layers = props?.securityLayers
  // se excluye el primer elemento ya que ahora se posiciona al final de todos los campos
  const headers = _.slice(_headers_concat, 1, _headers_concat.length)

  useEffect(() => {
    setFilter(getDataFilter(data, "created"))
  }, [data])

  useEffect(() => {
    if (isValid === true) {
      setData(data);
      setValid(false)
    }
  }, [isValid])

  const validateEmptyFields = (item) => {
    return (!validateEmail(item.value) || !validateName(item.name))
  }

  const validateBlankSpaces = (item) => {
    return (validateEmail(item.value) || validateName(item.name) || validateName(item.identifier) || validateName(item.controldoc_id))
  }

  const handleValues = (_data) => {
    _data = _.filter(_data, function (item, index) {
      if (validateBlankSpaces(item)) {
        return item
      }
    })
    const dataRepeatIdentifier = repeatDataFilter(_data, "identifier");
    const dataRepeatEmail = repeatDataFilter(_data, "value");

    _.each(_data, function (item, index) {
      item.id = Date.now() + index;

      if (!validateName(item.controldoc_id)) {
        item.state = "created";
      }

      let repeatIdentifier = !!_.find(dataRepeatIdentifier, { row: item.row });
      let repeatEmail = !!_.find(dataRepeatEmail, { row: item.row });

      if ((repeatIdentifier && item.row === repeatIdentifier.row) ||
        (repeatEmail && item.row === repeatEmail.row) ||
        validateEmptyFields(item)) {
        item.state = "error";
      }
    });
    setData(_data);
  }

  const onChangeCellValues = (value, row, key, customField) => {
    if (!value) {
      return;
    }

    setData(prevData => {
      const newData = [...prevData];
      // Find item by unique ID instead of index
      const itemIndex = newData.findIndex(item => item.id === row.id);
      if (itemIndex !== -1) {
        newData[itemIndex] = { ...newData[itemIndex], [key]: value };

        if (key == "identifier" || key == "value") {
          let repeatedData = _.filter(newData, (item) => item == row).length > 1

          if ((!!repeatedData && row.id === repeatedData.id) ||
            validateEmptyFields(row)) {
            newData[itemIndex] = { ...newData[itemIndex], state: "error" };
          }
        }
      }

      return newData;
    });
  };

  const repeatDataFilter = (_data, option) => {
    return _.filter(_data, (value, currentIndex, _array) => {
      return _.findIndex(_array, obj => {
        let index = _.findIndex(_array, item => JSON.stringify(item[option]) === JSON.stringify(value[option]));
        if (index === currentIndex) {
          return value;
        }
      })
    });
  }

  const renderActions = (rowData) => {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Button
          color="danger"
          outline
          className="border-0"
          onClick={(e) => handleDestroyEmployee(rowData)}
        >
          <i className="fas fa-trash-alt" />
        </Button>
        {drawSpanEmployeeNew(rowData)}
      </div>
    );
  }



  const drawSpanEmployeeNew = (row) => {
    if (!validateName(row.controldoc_id)) {
      return (
        <div className="d-inline-block m-2">
          <span id="tooltipTonNewEmployee">
            <i className="fas fa-user-plus text-info" />
          </span>
          <UncontrolledTooltip key={_.uniqueId(row.id)} placement="bottom" target="tooltipTonNewEmployee">
            {I18n.t('actions.create')} {I18n.t('activerecord.models.laboral/employee.one')}
          </UncontrolledTooltip>
        </div>
      )
    }
  }

  const handleDestroyEmployee = (row) => {
    swal.fire(alertConfirmDelete()).then((result) => {
      if (result.isConfirmed) {
        let filteredArray = _.filter(data, item => (item.id === row.id) ? item.is_deleted = true : item);
        setData(filteredArray);
      }
    })
  };

  const drawEmployees = () => {
    if (filter && filter?.length > 0) {
      return (
        <LaboralBulkLoadEmployeeTable
          data={filter}
          dataKey="id"
          customFieldsHeaders={props.customFieldsHeaders}
          currentUser={props?.currentUser}
          securityLayers={_security_layers}
          actionsRenderer={renderActions}
          onDataChange={onChangeCellValues}
          title={<Label>{I18n.t('laboral.bulk.load.employees.form.table.title')} ({`${filter?.length}`})</Label>}
          includeSecurityLayer={_.includes(headers, 'security_layer')}
        />
      )
    }
  }

  const handleConfirmSubmit = (e) => {
    e.preventDefault();
    swal.fire({
      title: 'Realizar carga masiva de trabajadores',
      html: '¿Estás seguro de realizar la carga masiva?',
      cancelButtonText: "<i class='fa fa-thumbs-down'></i> Cancelar",
      confirmButtonText: "<i class='fa fa-thumbs-up'></i> Confirmar",
      reverseButtons: true,
      showCancelButton: true,
      customClass: {
        confirmButton: 'btn btn-success ml-3',
        cancelButton: 'btn btn-secondary'
      },
      buttonsStyling: false,
    }).then(result => {
      if (result.isConfirmed) {
        let _form = document.getElementById("new_laboral_bulk_load_employee")
        setDisabledSubmitButton(true)
        _form.submit()
      }
    })
  }

  const drawTextSubmitButton = () => {
    if (disabledSubmitButton) {
      return I18n.t('actions.saving')
    } else {
      return I18n.t('actions.save')
    }
  }

  const drawBtnSubmit = () => {
    if (filter?.length > 0) {
      return (
        <button
          type='submit'
          className='btn btn-success ml-2'
          onClick={e => handleConfirmSubmit(e)}
          disabled={disabledSubmitButton}
        >
          {drawTextSubmitButton()}
        </button>
      )
    }
  }

  const handleRetryEmployee = (newData) => {
    setData(newData);
  }

  return (
    <div className="row">
      <form action={Routes.laboral_bulk_load_employees_path()} encType="multipart/form-data" method="post" id="new_laboral_bulk_load_employee">
        <input type="hidden" name="authenticity_token" value={window.compliance.token} />
        <div className="col-12">
          <LaboralBulkLoadEmployeeFileInput
            headers={headers}
            handleValues={handleValues}
            formName={formName}
            customFieldsHeaders={props?.customFieldsHeaders || []}
          />
        </div>
        <div className="col-12">
          <LaboralBulkLoadEmployeeListHidden
            customFields={props.customFieldsHeaders}
            currentUser={props?.currentUser}
            formName={formName}
            filter={filter}
          />
        </div>
        <div className="col-12 py-2">
          <LaboralBulkLoadEmployeeTableErrors
            data={data}
            onChangeCellValues={onChangeCellValues}
            customFieldsHeaders={_.map(props.customFieldsHeaders)}
            handleRetryEmployee={handleRetryEmployee}
            currentUser={props?.currentUser}
            isValid={isValid}
          />
        </div>
        <div className="col-12">
          {drawEmployees()}
        </div>
        <FormGroup className='text-end'>
          <a
            href={Routes.laboral_bulk_load_employees_path()}
            className='btn btn-default'
          >
            {I18n.t('actions.back')}
          </a>
          {drawBtnSubmit()}
        </FormGroup>
      </form>
    </div>
  )
}

export default LaboralBulkLoadEmployeeForm;
